module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section section-white content-padded",
    attrs: {
      "onload": "init()"
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "店铺名称"
    }
  }, [_c('div', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请先完成下方地理位置的选择"
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "店铺编号(英克ID)"
    }
  }, [_c('div', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.number),
      callback: function($$v) {
        _vm.$set(_vm.form, "number", $$v)
      },
      expression: "form.number"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("  店铺编号必填，若没有英克ID请以：大写字母S+店铺名缩写+随机数做为店铺编号")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商家id"
    }
  }, [_c('div', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.merchant_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "merchant_id", $$v)
      },
      expression: "form.merchant_id"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("  第三方店铺需要填写商家id,没有则暂时不填")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "门店平台"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "门店平台"
    },
    on: {
      "change": _vm.handlePlatform
    },
    model: {
      value: (_vm.form.store_platform_str),
      callback: function($$v) {
        _vm.$set(_vm.form, "store_platform_str", $$v)
      },
      expression: "form.store_platform_str"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "怡康到家",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "每一天",
      "value": "2"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_c('el-col', [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.store_platform),
      callback: function($$v) {
        _vm.$set(_vm.form, "store_platform", $$v)
      },
      expression: "form.store_platform"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "店铺类型"
    }
  }, [_c('el-checkbox-group', {
    on: {
      "change": _vm.handleCheckedShoptypeChange
    },
    model: {
      value: (_vm.form.shop_type_arr),
      callback: function($$v) {
        _vm.$set(_vm.form, "shop_type_arr", $$v)
      },
      expression: "form.shop_type_arr"
    }
  }, _vm._l((_vm.shop_type_list), function(shop) {
    return _c('el-checkbox', {
      key: shop.shop_type_id,
      attrs: {
        "label": shop.shop_type_id,
        "value": shop.shop_type_name
      }
    }, [_vm._v(" " + _vm._s(shop.shop_type_name) + "\n        ")])
  }), 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_c('el-col', [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.shop_type_str),
      callback: function($$v) {
        _vm.$set(_vm.form, "shop_type_str", $$v)
      },
      expression: "form.shop_type_str"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所属大区",
      "prop": "office_area_id"
    }
  }, [_c('el-cascader', {
    attrs: {
      "placeholder": "所属大区",
      "options": _vm.office_area,
      "props": {
        checkStrictly: true
      },
      "clearable": ""
    },
    on: {
      "change": _vm.handleOfficeChange
    },
    model: {
      value: (_vm.selected_office_area_id),
      callback: function($$v) {
        _vm.selected_office_area_id = $$v
      },
      expression: "selected_office_area_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_c('el-col', [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.office_area_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "office_area_id", $$v)
      },
      expression: "form.office_area_id"
    }
  })], 1), _vm._v(" "), _c('el-col', [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.office_area_pid),
      callback: function($$v) {
        _vm.$set(_vm.form, "office_area_pid", $$v)
      },
      expression: "form.office_area_pid"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "地理位置"
    }
  }, [_c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("店铺定位后保存店铺经纬度，才可以开启自提，否则店铺不支持自提功能")]), _vm._v(" "), _c('el-cascader', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "options": _vm.regions
    },
    on: {
      "change": _vm.handleRegionChange
    },
    model: {
      value: (_vm.form.regions_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "regions_id", $$v)
      },
      expression: "form.regions_id"
    }
  }), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "500px"
    },
    attrs: {
      "id": "keyword",
      "placeholder": "请输入地址"
    },
    model: {
      value: (_vm.form.address),
      callback: function($$v) {
        _vm.$set(_vm.form, "address", $$v)
      },
      expression: "form.address"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.searchKeyword()
      }
    }
  }, [_vm._v("搜索定位")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "地图定位"
    }
  }, [_c('div', {
    attrs: {
      "id": "qqmap_container"
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "电子围栏"
    }
  }, [_c('div', {
    attrs: {
      "id": "qqglmap_container"
    }
  })]), _vm._v(" "), _c('el-form-item', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": "true",
      "label": "腾讯电子围栏地址"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-input', {
    attrs: {
      "readonly": "",
      "placeholder": "电子围栏地址"
    },
    model: {
      value: (_vm.form.scope_tx),
      callback: function($$v) {
        _vm.$set(_vm.form, "scope_tx", $$v)
      },
      expression: "form.scope_tx"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": "true",
      "label": "腾讯经纬度"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-input', {
    attrs: {
      "readonly": "",
      "placeholder": "经度"
    },
    model: {
      value: (_vm.form.lng),
      callback: function($$v) {
        _vm.$set(_vm.form, "lng", $$v)
      },
      expression: "form.lng"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "content-center",
    attrs: {
      "span": 1
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-input', {
    attrs: {
      "readonly": "",
      "placeholder": "纬度"
    },
    model: {
      value: (_vm.form.lat),
      callback: function($$v) {
        _vm.$set(_vm.form, "lat", $$v)
      },
      expression: "form.lat"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "55%"
    },
    attrs: {
      "placeholder": "联系人"
    },
    model: {
      value: (_vm.form.contact),
      callback: function($$v) {
        _vm.$set(_vm.form, "contact", $$v)
      },
      expression: "form.contact"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系方式"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "55%"
    },
    attrs: {
      "placeholder": "请输入手机号"
    },
    model: {
      value: (_vm.form.mobile),
      callback: function($$v) {
        _vm.$set(_vm.form, "mobile", $$v)
      },
      expression: "form.mobile"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "固定电话"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "55%"
    },
    attrs: {
      "placeholder": "请输入固定电话"
    },
    model: {
      value: (_vm.form.telephone),
      callback: function($$v) {
        _vm.$set(_vm.form, "telephone", $$v)
      },
      expression: "form.telephone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "营业时间"
    }
  }, [_c('el-time-select', {
    attrs: {
      "placeholder": "起始时间",
      "picker-options": {
        start: '00:00',
        step: '00:30',
        end: '24:00'
      }
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  }), _vm._v(" "), _c('el-time-select', {
    attrs: {
      "placeholder": "结束时间",
      "picker-options": {
        start: '00:00',
        step: '00:30',
        end: '24:00',
        minTime: _vm.startTime
      }
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "frm-tips"
  }, [_vm._v("24小时制，如10：00-20：30")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "店铺服务"
    }
  }, [_c('el-checkbox-group', {
    on: {
      "change": _vm.serviceFormat
    },
    model: {
      value: (_vm.form.service_arr),
      callback: function($$v) {
        _vm.$set(_vm.form, "service_arr", $$v)
      },
      expression: "form.service_arr"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "中医"
    }
  }, [_vm._v("中医")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "代煎"
    }
  }, [_vm._v("代煎")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "自提"
    }
  }, [_vm._v("自提")])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_c('el-col', [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.service),
      callback: function($$v) {
        _vm.$set(_vm.form, "service", $$v)
      },
      expression: "form.service"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "延迟推送时间"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "15%"
    },
    attrs: {
      "placeholder": "时间范围：1-15/单位：分钟"
    },
    model: {
      value: (_vm.form.push_count_down),
      callback: function($$v) {
        _vm.$set(_vm.form, "push_count_down", $$v)
      },
      expression: "form.push_count_down"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "配送方式"
    }
  }, [_c('el-checkbox-group', {
    on: {
      "change": _vm.shippingTypeFormat
    },
    model: {
      value: (_vm.form.shipping_type_arr),
      callback: function($$v) {
        _vm.$set(_vm.form, "shipping_type_arr", $$v)
      },
      expression: "form.shipping_type_arr"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("蜂鸟")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "2"
    }
  }, [_vm._v("美团")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "3"
    }
  }, [_vm._v("达达")])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_c('el-col', [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.shipping_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "shipping_type", $$v)
      },
      expression: "form.shipping_type"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "评分"
    }
  }, [_c('el-rate', {
    attrs: {
      "show-score": "",
      "allow-half": "",
      "score-template": "{value}"
    },
    model: {
      value: (_vm.form.rate),
      callback: function($$v) {
        _vm.$set(_vm.form, "rate", $$v)
      },
      expression: "form.rate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "起送门槛设置"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "15%"
    },
    attrs: {
      "placeholder": "例如:20元起送"
    },
    model: {
      value: (_vm.form.threshold_setting),
      callback: function($$v) {
        _vm.$set(_vm.form, "threshold_setting", $$v)
      },
      expression: "form.threshold_setting"
    }
  }), _vm._v(" 元起送\n    ")], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "配送描述"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "55%"
    },
    attrs: {
      "placeholder": "请输入配送描述"
    },
    model: {
      value: (_vm.form.delivery_spe),
      callback: function($$v) {
        _vm.$set(_vm.form, "delivery_spe", $$v)
      },
      expression: "form.delivery_spe"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "店铺LOGO"
    }
  }, [_c('div', {
    staticClass: "upload-box",
    on: {
      "click": function($event) {
        return _vm.handleImgPicker('logo')
      }
    }
  }, [(_vm.form.logo) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.form.logo
    }
  }) : _c('i', {
    staticClass: "iconfont icon-camera avatar-uploader-icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("只能上传jpg/png文件，且不超过2M")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "店铺横幅广告"
    }
  }, [_c('div', {
    staticClass: "upload-box",
    on: {
      "click": function($event) {
        return _vm.handleImgPicker('banner')
      }
    }
  }, [(_vm.form.banner) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.form.banner
    }
  }) : _c('i', {
    staticClass: "iconfont icon-camera avatar-uploader-icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("只能上传jpg/png文件，且不超过2M")])]), _vm._v(" "), (this.$store.getters.login_type != 'distributor') ? _c('el-form-item', {
    attrs: {
      "label": "自动上架商品"
    }
  }, [_c('el-switch', {
    attrs: {
      "inactive-color": "#ff4949",
      "active-color": "#13ce66"
    },
    model: {
      value: (_vm.form.auto_sync_goods),
      callback: function($$v) {
        _vm.$set(_vm.form, "auto_sync_goods", $$v)
      },
      expression: "form.auto_sync_goods"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("开启后，店铺自动上架总部商品; 取消自动下架后，将保留店铺已上架的商品")])], 1) : _vm._e(), _vm._v(" "), (this.$store.getters.login_type != 'distributor' && _vm.system_mode === 'platform') ? _c('el-form-item', {
    attrs: {
      "label": "审核商品"
    }
  }, [_c('el-switch', {
    attrs: {
      "inactive-color": "#ff4949",
      "active-color": "#13ce66"
    },
    model: {
      value: (_vm.form.is_audit_goods),
      callback: function($$v) {
        _vm.$set(_vm.form, "is_audit_goods", $$v)
      },
      expression: "form.is_audit_goods"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("开启后，店铺添加的自有商品，需要平台审核通过后才可以上架")])], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否自提"
    }
  }, [(!_vm.form.lng && !_vm.form.lat) ? _c('el-switch', {
    attrs: {
      "disabled": "",
      "active-color": "#13ce66",
      "inactive-color": "#ff4949"
    },
    model: {
      value: (_vm.form.is_ziti),
      callback: function($$v) {
        _vm.$set(_vm.form, "is_ziti", $$v)
      },
      expression: "form.is_ziti"
    }
  }) : _c('el-switch', {
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#ff4949"
    },
    model: {
      value: (_vm.form.is_ziti),
      callback: function($$v) {
        _vm.$set(_vm.form, "is_ziti", $$v)
      },
      expression: "form.is_ziti"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否启用"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-value": "true",
      "inactive-value": "false",
      "active-color": "#13ce66",
      "inactive-color": "#ff4949"
    },
    model: {
      value: (_vm.form.is_valid),
      callback: function($$v) {
        _vm.$set(_vm.form, "is_valid", $$v)
      },
      expression: "form.is_valid"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否开启营业"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-value": "true",
      "inactive-value": "false",
      "active-color": "#13ce66",
      "inactive-color": "#ff4949"
    },
    model: {
      value: (_vm.form.is_open),
      callback: function($$v) {
        _vm.$set(_vm.form, "is_open", $$v)
      },
      expression: "form.is_open"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否自动接单"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-value": "true",
      "inactive-value": "false",
      "active-color": "#13ce66",
      "inactive-color": "#ff4949"
    },
    model: {
      value: (_vm.form.auto_receive),
      callback: function($$v) {
        _vm.$set(_vm.form, "auto_receive", $$v)
      },
      expression: "form.auto_receive"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否开启快递配送"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#ff4949"
    },
    model: {
      value: (_vm.form.isExpress),
      callback: function($$v) {
        _vm.$set(_vm.form, "isExpress", $$v)
      },
      expression: "form.isExpress"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "第三方门店"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#ff4949"
    },
    model: {
      value: (_vm.form.is_third),
      callback: function($$v) {
        _vm.$set(_vm.form, "is_third", $$v)
      },
      expression: "form.is_third"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "第三方平台"
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "placeholder": "第三方平台"
    },
    model: {
      value: (_vm.form.is_third_plant),
      callback: function($$v) {
        _vm.$set(_vm.form, "is_third_plant", $$v)
      },
      expression: "form.is_third_plant"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "------",
      "value": ""
    }
  })], 1)], 1), _vm._v(" "), (_vm.form.merchant_id > 0) ? _c('el-form-item', {
    attrs: {
      "label": "第三方收银平台"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": "disabled"
    },
    model: {
      value: (_vm.form.third_plant_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "third_plant_type", $$v)
      },
      expression: "form.third_plant_type"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "keruyun"
    }
  }, [_vm._v("客如云")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "meituan"
    }
  }, [_vm._v("美团")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "hualala"
    }
  }, [_vm._v("哗啦啦")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "tcsl"
    }
  }, [_vm._v("天财商龙")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "feie"
    }
  }, [_vm._v("飞鹅打印机")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.form.merchant_id > 0) ? _c('el-form-item', {
    attrs: {
      "label": "第三方门店id"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "55%"
    },
    attrs: {
      "disabled": "disabled"
    },
    model: {
      value: (_vm.form.third_distributor_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "third_distributor_id", $$v)
      },
      expression: "form.third_distributor_id"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "*店铺图片"
    }
  }, [_c('div', [_c('div', {
    staticClass: "pics-box"
  }, [_c('ul', {
    staticClass: "goodspic-wrap"
  }, [_c('draggable', {
    staticClass: "components-view",
    attrs: {
      "options": _vm.dragIssuesOptions
    },
    model: {
      value: (_vm.form.store_images),
      callback: function($$v) {
        _vm.$set(_vm.form, "store_images", $$v)
      },
      expression: "form.store_images"
    }
  }, _vm._l((_vm.form.store_images), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "goodspic",
      on: {
        "mouseenter": function($event) {
          return _vm.storeImagesEnter0(index)
        },
        "mouseleave": _vm.storeImagesLeave0
      }
    }, [_c('el-image', {
      ref: "imageStoreRef",
      refInFor: true,
      attrs: {
        "src": _vm.wximageurl + item,
        "show-progress": "",
        "preview-src-list": _vm.form.store_images,
        "fit": "cover"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "goodspic-mask",
      class: (_vm.storeImagesCurrent == index) ? 'on' : ''
    }, [_c('div', {
      staticClass: "iconfont icon-trash-alt",
      on: {
        "click": function($event) {
          return _vm.removeStoreImages0(index)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "iconfont icon-arrows-alt"
    }), _vm._v(" "), _c('div', {
      staticClass: "iconfont icon-eye",
      on: {
        "click": function($event) {
          return _vm.handlePreview(index)
        }
      }
    })])], 1)
  }), 0)], 1), _vm._v(" "), (_vm.form.store_images.length < 9) ? _c('div', {
    staticClass: "upload-box",
    on: {
      "click": _vm.handleStoreImagesChange0
    }
  }, [_c('i', {
    staticClass: "iconfont icon-camera"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_c('p', [_vm._v("1. 最多可上传9个图片，文件格式为bmp、png、jpeg、jpg或gif，大小不超过2M（建议尺寸：500px * 500px）")]), _vm._v(" "), _c('p', [_vm._v("2. 拖动图片进行可排序")])])]), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.storeImagesDialog,
      "sc-status": _vm.isGetStoreImages,
      "is-most": _vm.multiple
    },
    on: {
      "chooseImg": _vm.pickStoreImages0,
      "closeImgDialog": _vm.closeStoreImagesDialog0
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "*店铺资质图片"
    }
  }, [_c('div', [_c('div', {
    staticClass: "pics-box"
  }, [_c('ul', {
    staticClass: "goodspic-wrap"
  }, [_c('draggable', {
    staticClass: "components-view",
    attrs: {
      "options": _vm.dragIssuesOptions
    },
    model: {
      value: (_vm.form.cert_images),
      callback: function($$v) {
        _vm.$set(_vm.form, "cert_images", $$v)
      },
      expression: "form.cert_images"
    }
  }, _vm._l((_vm.form.cert_images), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "goodspic",
      on: {
        "mouseenter": function($event) {
          return _vm.storeImagesEnter2(index)
        },
        "mouseleave": _vm.storeImagesLeave2
      }
    }, [_c('el-image', {
      ref: "imageCertRef",
      refInFor: true,
      attrs: {
        "src": _vm.wximageurl + item,
        "show-progress": "",
        "preview-src-list": _vm.form.cert_images,
        "fit": "cover"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "goodspic-mask",
      class: (_vm.storeImagesCurrent2 == index) ? 'on' : ''
    }, [_c('div', {
      staticClass: "iconfont icon-trash-alt",
      on: {
        "click": function($event) {
          return _vm.removeStoreImages2(index)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "iconfont icon-arrows-alt"
    }), _vm._v(" "), _c('div', {
      staticClass: "iconfont icon-eye",
      on: {
        "click": function($event) {
          return _vm.handleCertPreview(index)
        }
      }
    })])], 1)
  }), 0)], 1), _vm._v(" "), (_vm.form.cert_images.length < 9) ? _c('div', {
    staticClass: "upload-box",
    on: {
      "click": _vm.handleStoreImagesChange2
    }
  }, [_c('i', {
    staticClass: "iconfont icon-camera"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_c('p', [_vm._v("1. 最多可上传9个图片，文件格式为bmp、png、jpeg、jpg或gif，大小不超过2M（建议尺寸：500px * 500px）")]), _vm._v(" "), _c('p', [_vm._v("2. 拖动图片进行可排序")])])]), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.storeImagesDialog2,
      "sc-status": _vm.isGetStoreImages2,
      "is-most": _vm.multiple2
    },
    on: {
      "chooseImg": _vm.pickStoreImages2,
      "closeImgDialog": _vm.closeStoreImagesDialog2
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "营业执照"
    }
  }, [_c('div', {
    staticClass: "upload-box",
    on: {
      "click": function($event) {
        return _vm.handleImgPicker('yyzz')
      }
    }
  }, [(_vm.form.yyzz) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.form.yyzz
    }
  }) : _c('i', {
    staticClass: "iconfont icon-camera avatar-uploader-icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("只能上传jpg/png文件，且不超过2M")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "营业执照编号"
    }
  }, [_c('div', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.yyzzbh),
      callback: function($$v) {
        _vm.$set(_vm.form, "yyzzbh", $$v)
      },
      expression: "form.yyzzbh"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "食品经营许可证"
    }
  }, [_c('div', {
    staticClass: "upload-box",
    on: {
      "click": function($event) {
        return _vm.handleImgPicker('spjyxkz')
      }
    }
  }, [(_vm.form.spjyxkz) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.form.spjyxkz
    }
  }) : _c('i', {
    staticClass: "iconfont icon-camera avatar-uploader-icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("只能上传jpg/png文件，且不超过2M")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "食品经营许可证编号"
    }
  }, [_c('div', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.spjyxkzbh),
      callback: function($$v) {
        _vm.$set(_vm.form, "spjyxkzbh", $$v)
      },
      expression: "form.spjyxkzbh"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "药品经营许可证"
    }
  }, [_c('div', {
    staticClass: "upload-box",
    on: {
      "click": function($event) {
        return _vm.handleImgPicker('ypjyxkz')
      }
    }
  }, [(_vm.form.ypjyxkz) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.form.ypjyxkz
    }
  }) : _c('i', {
    staticClass: "iconfont icon-camera avatar-uploader-icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("只能上传jpg/png文件，且不超过2M")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "药品经营许可证编号"
    }
  }, [_c('div', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.ypjyxkzbh),
      callback: function($$v) {
        _vm.$set(_vm.form, "ypjyxkzbh", $$v)
      },
      expression: "form.ypjyxkzbh"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "医疗器械许可证"
    }
  }, [_c('div', {
    staticClass: "upload-box",
    on: {
      "click": function($event) {
        return _vm.handleImgPicker('ylqxxkz')
      }
    }
  }, [(_vm.form.ylqxxkz) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.form.ylqxxkz
    }
  }) : _c('i', {
    staticClass: "iconfont icon-camera avatar-uploader-icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("只能上传jpg/png文件，且不超过2M")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "医疗器械许可证编号"
    }
  }, [_c('div', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.ylqxxkzbh),
      callback: function($$v) {
        _vm.$set(_vm.form, "ylqxxkzbh", $$v)
      },
      expression: "form.ylqxxkzbh"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "二类医疗器械许可证"
    }
  }, [_c('div', {
    staticClass: "upload-box",
    on: {
      "click": function($event) {
        return _vm.handleImgPicker('elylqxxkz')
      }
    }
  }, [(_vm.form.elylqxxkz) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.form.elylqxxkz
    }
  }) : _c('i', {
    staticClass: "iconfont icon-camera avatar-uploader-icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("只能上传jpg/png文件，且不超过2M")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "二类医疗器械许可证编号"
    }
  }, [_c('div', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.elylqxxkzbh),
      callback: function($$v) {
        _vm.$set(_vm.form, "elylqxxkzbh", $$v)
      },
      expression: "form.elylqxxkzbh"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "三类医疗器械许可证"
    }
  }, [_c('div', {
    staticClass: "upload-box",
    on: {
      "click": function($event) {
        return _vm.handleImgPicker('slylqxxkz')
      }
    }
  }, [(_vm.form.slylqxxkz) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.form.slylqxxkz
    }
  }) : _c('i', {
    staticClass: "iconfont icon-camera avatar-uploader-icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("只能上传jpg/png文件，且不超过2M")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "三类医疗器械许可证编号"
    }
  }, [_c('div', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.slylqxxkzbh),
      callback: function($$v) {
        _vm.$set(_vm.form, "slylqxxkzbh", $$v)
      },
      expression: "form.slylqxxkzbh"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "药师注册证"
    }
  }, [_c('div', {
    staticClass: "upload-box",
    on: {
      "click": function($event) {
        return _vm.handleImgPicker('yszcz')
      }
    }
  }, [(_vm.form.yszcz) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.form.yszcz
    }
  }) : _c('i', {
    staticClass: "iconfont icon-camera avatar-uploader-icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("只能上传jpg/png文件，且不超过2M")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "药师注册证编号"
    }
  }, [_c('div', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.yszczbh),
      callback: function($$v) {
        _vm.$set(_vm.form, "yszczbh", $$v)
      },
      expression: "form.yszczbh"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "section-footer with-border content-center"
  }, [_c('el-button', {
    attrs: {
      "size": "large"
    },
    on: {
      "click": _vm.cancelSubmit
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.submitItemsActionConfirm
    }
  }, [_vm._v(_vm._s(_vm.submitLoading ? '提交中' :
    '保存') + "\n      ")])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.qqmap_infowin_flag),
      expression: "qqmap_infowin_flag"
    }],
    attrs: {
      "id": "qqmap_infowin"
    }
  }, [_c('el-col', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.imp_poi(_vm.poi_info)
      }
    }
  }, [_vm._v("导入该位置信息")])], 1), _vm._v(" "), _c('el-col', [_vm._v(_vm._s(_vm.poi_info.name))]), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_vm._v(" " + _vm._s(_vm.poi_info.address))])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.new_qqmap_info_flag),
      expression: "new_qqmap_info_flag"
    }],
    attrs: {
      "id": "new_qqmap_info"
    }
  }, [_c('el-col', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.new_imp_poi(_vm.new_poi_info)
      }
    }
  }, [_vm._v("导入该位置")])], 1), _vm._v(" "), _c('el-col'), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  })], 1), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.imgDialog,
      "sc-status": _vm.isGetImage
    },
    on: {
      "chooseImg": _vm.pickImg,
      "closeImgDialog": _vm.closeImgDialog
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-23da80c6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23da80c6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/marketing/distributor_editor.vue
// module id = 2539
// module chunks = 0